import type {Ref} from "vue";

export default class CongratulationPopup {

    private static instance: CongratulationPopup;
    private static creating: boolean = false;
    private showRef: Ref<boolean> | null = null;
    private popupBlock: HTMLElement | null = null;


    private constructor() {
        if (!CongratulationPopup.creating) {
            throw new Error("You must use ChatCounterService.getInstance() to create an instance.");
        }

    }


    static getInstance(): CongratulationPopup {
        if (!CongratulationPopup.instance) {
            CongratulationPopup.creating = true;
            CongratulationPopup.instance = new CongratulationPopup();
            CongratulationPopup.creating = false;
        }
        return CongratulationPopup.instance;
    }

    public init(showRef: Ref<boolean>, popupBlock: HTMLElement ): void {
        this.showRef = showRef;
        this.popupBlock = popupBlock;
    }


    public show( ): CongratulationPopup {
        if (this.showRef) {
            this.showRef.value = true;
        }
        setTimeout(() => {
            this.hide()
        }, 4000)
        return this
    }

    public hide(): void {
        if (this.showRef) {
            this.showRef.value = false;
        }
    }
}
